import { Grid, SingleSelect } from "designSystem/index";
import React from "react";
import { items } from "designSystemLegacy/data";

export default () => {
	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<SingleSelect
					options={items}
					required
					value={items[0]}
				/>
			</Grid>
		</Grid>
	);
};